import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
	fetchOrAdd as fetchOrAddApi,
	addCandidate,
	fetchCandidateByPhone,
	fetchCandidateBySource,
	fetchCandidateById,
	getCandidates,
	searchCandidates,
	getICIMSCandidateData,
	getMessageTemplates,
	updateCandidateChannel
} from 'util/Api/user';

const resetState = createAction('candidate/resetState');

const fetchOrAdd = createAsyncThunk(
	'candidate/fetchOrAdd',
	async ({ firstName, lastName, phoneNumber, channel }, { rejectWithValue }) => {
		try {
			return await fetchOrAddApi(firstName, lastName, phoneNumber, channel);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const add = createAsyncThunk(
	'candidate/add',
	async ({ firstName, lastName, phoneNumber, channel, source, sourceId }, { rejectWithValue }) => {
		try {
			return await addCandidate(firstName, lastName, phoneNumber, channel, source, sourceId);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const fetchByPhone = createAsyncThunk(
	'candidate/fetchByPhone',
	async ({ phoneNumber }, { rejectWithValue }) => {
		try {
			return await fetchCandidateByPhone(phoneNumber);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const fetchBySource = createAsyncThunk(
	'candidate/fetchBySource',
	async ({ source, sourceId, sourceIdType }, { rejectWithValue }) => {
		try {
			return await fetchCandidateBySource(source, sourceId, sourceIdType);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const fetchById = createAsyncThunk('candidate/fetchById', async ({ id }, { rejectWithValue }) => {
	try {
		return await fetchCandidateById(id);
	} catch (err) {
		return rejectWithValue(err);
	}
});

const fetchCandidates = createAsyncThunk(
	'candidate/fetchCandidates',
	async ({ pageNumber }, { rejectWithValue }) => {
		try {
			return await getCandidates(pageNumber);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const search = createAsyncThunk('candidate/search', async ({ value }, { rejectWithValue }) => {
	try {
		return await searchCandidates(value);
	} catch (err) {
		return rejectWithValue(err);
	}
});

const fetchICIMSData = createAsyncThunk(
	'fetchICIMSData',
	// eslint-disable-next-line require-await
	async ({ messageTemplates, candidateId }, { rejectWithValue }) => {
		try {
			let shouldRetrieveICIMSData = false;

			// If any of the message templates have icims-placeholder we need to retrieve corresponding data
			messageTemplates.forEach((template) => {
				// eslint-disable-next-line no-implicit-coercion, no-bitwise
				if (~template.text.indexOf('{{icims')) {
					shouldRetrieveICIMSData = true;
				}
			});
			if (shouldRetrieveICIMSData) {
				return () => getICIMSCandidateData(candidateId);
				// eslint-disable-next-line no-else-return
			} else return {};
			// TODO: Has to be rewritten/refactored as this is to make it work without errors as of now.
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const updateChannel = createAsyncThunk(
	'candidate/updateChannel',
	async ({ candidateId, channel }, { rejectWithValue }) => {
		try {
			return await updateCandidateChannel(candidateId, channel);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const fetchAllTemplates = createAsyncThunk(
	'fetchAllTemplates',
	async ({ userName }, { rejectWithValue }) => {
		try {
			const response = await getMessageTemplates();
			// eslint-disable-next-line dot-notation
			response['userName'] = userName;
			return response;
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const updateDoNotTextFlag = createAction('candidate/updateDoNotTextFlag');

export const candidateActions = {
	resetState,
	fetchOrAdd,
	add,
	fetchByPhone,
	fetchBySource,
	fetchById,
	fetchCandidates,
	search,
	fetchAllTemplates,
	fetchICIMSData,
	updateChannel,
	updateDoNotTextFlag
};
